module.exports = "<div class=\"content\">\n  <app-group class=\"group\" *ngFor=\"let group of groups;trackBy: group?.title\" [group]=\"group\"></app-group>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/index-page/index-page.component.html
// module id = 224
// module chunks = 1